import { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { get } from "lodash"
import "./style.scss"

class IntercomLauncher extends Component {
  static propTypes = {
    pinned: PropTypes.bool.isRequired,
    toggleLauncherPin: PropTypes.func.isRequired,
  }

  state = {
    opened: false,
    unreadMessages: 0,
  }

  componentDidMount() {
    // Check if the messenger window will be opened when the user loads the page
    const intercomState = localStorage.getItem("intercom.intercom-state")
    if (intercomState) {
      try {
        const { openOnBoot } = JSON.parse(intercomState)
        // If the type is not null, it means it will be opened
        if (get(openOnBoot, "type", null)) {
          this.setState({ opened: true })
        }
      } catch {
        // Nothing to do if it fails...
      }
    }

    window.Intercom("onShow", () => {
      this.setState({ opened: true })
    })

    window.Intercom("onHide", () => {
      this.setState({ opened: false })
    })

    window.Intercom("onUnreadCountChange", unreadMessages => {
      this.setState({ unreadMessages })
    })
  }

  componentDidUpdate(prevProps) {
    const { pinned, toggleLauncherPin } = this.props
    const { unreadMessages } = this.state
    if (!prevProps.pinned && (!pinned && unreadMessages > 0)) {
      toggleLauncherPin()
    }
  }

  render() {
    const { pinned, toggleLauncherPin } = this.props
    const { opened, unreadMessages } = this.state

    return <div className={classNames("ompnt-intercom-wrapper", { "pinned-launcher": pinned || opened })}>
      {unreadMessages !== 0 && <div className="unread-messages unread-messages-untacked">{unreadMessages}</div>}
      <div className="ompnt-intercom-launcher">
        <div id="ompnt-intercom-launcher-button">
          <div className={classNames("launcher-buttons", "intercom-messenger", { opened })} />
          <div className={classNames("launcher-buttons", "close-intercom-messenger", { opened })} />
          {unreadMessages !== 0 && <div className="unread-messages">{unreadMessages}</div>}
        </div>
        <div className="ompnt-intercom-pin-wrapper" onClick={toggleLauncherPin}>
          <i className={classNames("fa fa-thumb-tack", { pinned })} />
        </div>
      </div>
    </div>
  }
}

export default IntercomLauncher
